import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const fashionCats = categories.slice(0, 7);
  const accessCats = categories.slice(7);

  return (
    <footer className="bg-background-100">
      {/* Upper: Link Columns */}
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Fashion */}
          <div>
            <h4 className="font-label text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              Fashion
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2">
              {fashionCats.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-150 whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* Accessories */}
          <div>
            <h4 className="font-label text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              Accessories
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2">
              {accessCats.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-150 whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-label text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              Resources
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-150 whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/blog/pandabuy-spreadsheet-buying-guide"
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-150 whitespace-nowrap"
              >
                Buying Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-150 whitespace-nowrap"
              >
                Pandabuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-150 whitespace-nowrap"
              >
                Spreadsheet Database
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-label text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              Legal
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-500 whitespace-nowrap">© 2026 pandabuy.run</span>
              <span className="text-sm text-foreground-500 whitespace-nowrap">All rights reserved</span>
              <span className="text-xs text-foreground-400 mt-1">
                We are not affiliated with Pandabuy. All data is for informational purposes only.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Lower: Brand */}
      <div className="border-t border-background-200">
        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight leading-none">
                PANDABUY
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight leading-none">
                SHEET
              </div>
              <div className="w-12 h-px bg-foreground-300 my-2"></div>
              <p className="text-xs text-foreground-500">Curated spreadsheet index for smarter shopping</p>
            </div>

            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-500 hidden md:block">Stay updated</span>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 hover:bg-background-300 transition-colors cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 hover:bg-background-300 transition-colors cursor-pointer" aria-label="Reddit">
                  <i className="ri-reddit-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 hover:bg-background-300 transition-colors cursor-pointer" aria-label="Telegram">
                  <i className="ri-telegram-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-foreground-900 hover:bg-background-300 transition-colors cursor-pointer" aria-label="Discord">
                  <i className="ri-discord-line text-base"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}